import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import {
  PageHeader,
  DangerousWrapper,
  clip,
  stripHTML
} from '@budget-monorepo/shared-ui';
import Layout from '../components/Layout';
import HelmetData from '../components/HelmetData';

const Preambles = (props) => {
  // eslint-disable-next-line react/prop-types
  const { data } = props;
  const { content, site } = data;
  // eslint-disable-next-line camelcase
  const { modifiedTime, mg_mod_date, mg_mod_datetime } = content.parent;
  const layoutProps = {
    activeIndex: 2,
    above: () => <PageHeader title={content.title} category={content.budgetSection} />,
    pageTitle: `${content.title} ${content.budgetSection}`,
    dataTimeStamp: modifiedTime,
    buildTimeStamp: site.buildTime
  };
  // metadata for the page
  const metaTitle = `${content.budgetSection}: ${content.title}`;
  const metaDescription = clip(stripHTML(content.summary), 160);
  return(
    <Fragment>
      <HelmetData {...{
        metaTitle,
        metaDescription,
        mg_mod_date,
        mg_mod_datetime
      }}
      />
      <Layout {...layoutProps}>
        <div className="page-content">
          {content.summary && <DangerousWrapper className="ma__summary-section" rawHtml={content.summary} />}
          <DangerousWrapper rawHtml={content.content} />
        </div>
      </Layout>
    </Fragment>
  );
};

Preambles.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object,
  location: PropTypes.object
};

export default Preambles;

export const query = graphql`
  query($slug: String!){
    site {
      ...SiteMetadata
    }
    content: preamblesJson(fields: { slug: { eq: $slug } }) {
      title
      budgetSection
      summary
      content
      # Get the last modified timestamp for the file powering the page.
      ...PreamblesJsonDataTimeStamp
    }
  }
`;
